import { useContext } from "react";
import { AppContext } from "../App";
import { FiCpu, FiTrendingUp, FiLayers } from "react-icons/fi";


export default function DigitalExtended() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiCpu />,
      title: "Telemedicine & Remote Consultation",
      desc: "Remote consulting pipelines via designated secure platforms or telemetry apps tailored for Nanguba Care Program chronic disease management tracking."
    },
    {
      icon: <FiTrendingUp />,
      title: "Home Sample Collection Service",
      desc: "Premium field phlebotomy and specimen collection at home or workspace nodes. Samples are secured via cold-chain transit with results delivered directly to your device."
    },
    {
      icon: <FiLayers />,
      title: "Medical Records & Health Certificates",
      desc: "Clean, comprehensive, and auditable data registries providing official regulatory health records management, sick-leave indexing, and medico-legal reporting."
    }
  ];

  return (
    <div className="pillar-container">
      <div className="pillar-header">
        <h2 className="pillar-title">Digital & Extended Services</h2>
        <p className="pillar-subtitle">Extending modern healthcare capabilities beyond traditional brick-and-mortar limitations.</p>
      </div>

      <div className="pillar-grid">
        {services.map((item, idx) => (
          <div 
            key={idx} 
            className="pillar-card"
            onClick={() => appContext.navTo({ item: "contact_us" })}
          >
            <div className="pillar-icon">{item.icon}</div>
            <h3 className="pillar-card-title">{item.title}</h3>
            <p className="pillar-card-desc">{item.desc}</p>
          </div>
        ))}

      </div>
    </div>
  );
}